const YES_NO_CHECKBOX_VALUES = [
  { label: 'Oui', value: true },
  { label: 'Non', value: false }
];

export default YES_NO_CHECKBOX_VALUES;
